import Config from 'react-native-config';
import axios from 'axios';
import { platformURL } from 'modules/utils/UrlUtils';
import amwell from 'lib/amwellAxiosStub';

export const REQUEST_TIMEOUT_DURATION = Config.NETWORK_TIMEOUT_DURATION
  ? parseInt(Config.NETWORK_TIMEOUT_DURATION, 10)
  : 60000;

const createAxiosClient = (baseURL: string) =>
  axios.create({
    baseURL,
    responseType: 'json',
    timeout: REQUEST_TIMEOUT_DURATION
  });

const axiosClients = {
  default: {
    client: createAxiosClient(platformURL(Config.BOOKING_BASE_URL))
  },
  azureProviderSearch: { client: createAxiosClient(platformURL(Config.PROVIDER_AZURE_BASE_URL)) },
  billing: {
    client: createAxiosClient(platformURL(Config.BILLING_BASE_URL))
  },
  booking: {
    client: createAxiosClient(platformURL(Config.BOOKING_BASE_URL))
  },
  consumers: {
    client: createAxiosClient(Config.CONSUMERS_EXPANSION_BASE_URL || Config.PROFILE_BASE_URL)
  },
  dispatcher: {
    client: createAxiosClient(Config.DISPATCHER_BASE_URL)
  },
  imh: {
    client: createAxiosClient(platformURL(Config.IMH_URL))
  },
  profile: {
    client: createAxiosClient(platformURL(Config.PROFILE_BASE_URL))
  },
  preference: {
    client: createAxiosClient(platformURL(Config.PREFERENCE_BASE_URL))
  },
  mhpStatus: {
    client: createAxiosClient(platformURL(Config.MY_HEALTH_STATUS_BASE_URL))
  },
  myDoctors: {
    client: createAxiosClient(platformURL(Config.MYDOCTORS_BASE_URL))
  },
  getCare: {
    client: createAxiosClient(platformURL(Config.GETCARE_BASE_URL))
  },
  cost: {
    client: createAxiosClient(platformURL(Config.COST_BASE_URL))
  },
  triageGyant: {
    client: createAxiosClient(platformURL(Config.TRIAGE_GYANT_BASE_URL)),
    options: {
      interceptors: null
    }
  },
  costLocal: {
    client: createAxiosClient(platformURL(Config.COST_BASE_LOCAL_URL))
  },
  provider: {
    client: createAxiosClient(platformURL(Config.PROVIDER_BASE_URL))
  },
  insurance: {
    client: createAxiosClient(platformURL(Config.INSURANCE_BASE_URL))
  },
  notifications: {
    client: createAxiosClient(platformURL(Config.NOTIFICATIONS_BASE_URL))
  },
  orchestration: {
    client: createAxiosClient(platformURL(Config.ORCHESTRATION_BASE_URL_REST))
  },
  amwellAuthService: {
    client: createAxiosClient(platformURL(Config.AMWELL_AUTH_SERVICE_BASE_URL))
  },
  amwell: {
    client: amwell.create(),
    options: amwell.options()
  },
  visitSummary: {
    client: createAxiosClient(platformURL(Config.VISIT_SUMMARY_BASE_URL))
  },
  messaging: {
    client: createAxiosClient(Config.MESSAGING_EXPANSION_BASE_URL || Config.MESSAGING_BASE_URL)
  },
  events: {
    client: createAxiosClient(platformURL(Config.EVENTS_BASE_URL))
  },
  eventsGeneration: {
    client: createAxiosClient(platformURL(Config.EVENTS_GENERATION_URL))
  },
  audit: {
    client: createAxiosClient(platformURL(Config.AUDIT_BASE_URL))
  },
  webpay: {
    client: createAxiosClient(platformURL(Config.WEBPAY_BASE_URL))
  },
  binary: {
    client: createAxiosClient(
      platformURL(Config.BINARY_EXPANSION_BASE_URL || Config.BINARY_BASE_URL)
    )
  },
  testResults: {
    client: createAxiosClient(platformURL(Config.TEST_RESULTS_BASE_URL))
  },
  expansionCCD: {
    client: createAxiosClient(Config.CCD_EXPANSION_BASE_URL || Config.CCD_BASE_URL)
  },
  ccd: {
    client: createAxiosClient(platformURL(Config.CCD_BASE_URL))
  },
  financialAssistance: {
    client: createAxiosClient(platformURL(Config.FINANCIAL_ASSISTANCE_POST_URL))
  },
  hipaa: {
    client: createAxiosClient(platformURL(Config.HIPAA_EXPANSION_BASE_URL || Config.HIPAA_BASE_URL))
  },
  eob: {
    client: createAxiosClient(platformURL(Config.GRAPHQL_EOB_ENDPOINT_URL))
  },
  scanning: {
    client: createAxiosClient(platformURL(Config.SCANNING_BASE_URL))
  },
  symptomChecker: {
    client: createAxiosClient(platformURL(Config.SYMPTOM_CHECKER_BASE_URL))
  },
  tps: {
    client: createAxiosClient(platformURL(Config.TPS_BASE_URL))
  },
  uss: {
    client: createAxiosClient(platformURL(Config.USS_BASE_URL))
  },
  scheduling: {
    client: createAxiosClient(platformURL(Config.SCHEDULING_BASE_URL))
  },
  graphqlRest: {
    client: createAxiosClient(platformURL(Config.GRAPHQL_BASE_URL))
  }
};

export default axiosClients;
